module.exports = __webpack_public_path__ + "img/promo2.0f37d44.png";